import styled from 'styled-components'
import { portraitAspectRatio } from '@velasca/constants'
import { ResponsiveImage } from '../ResponsiveImage/ResponsiveImage'

export const VideoBlock = styled.div<{
  hasVideo: boolean
  isMobile?: boolean
}>`
  position: relative;
  background: transparent;
  margin: 3rem auto;
  z-index: 2;
  cursor: ${({ hasVideo }) => (hasVideo ? 'pointer' : 'default')};
  display: ${({ isMobile }) => (isMobile ? 'block' : 'none')};
  width: 70%;
  aspect-ratio: ${portraitAspectRatio};

  @supports not (aspect-ratio: portraitAspectRatio) {
    &::before {
      float: left;
      padding-top: 178.77%;
      content: '';
    }

    &::after {
      display: block;
      content: '';
      clear: both;
    }
  }

  @media screen and (min-width: 768px) {
    display: ${({ isMobile }) => (isMobile ? 'none' : 'block')};
    align-self: flex-end;
    width: 52%;
    margin-top: 0.5rem;
  }
`

export const VideoPreviewImage = styled(ResponsiveImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
export const ClickArea = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: ${({ theme }) => theme.colors.background};
  z-index: 3;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const VideoPlayerWithCover = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

export const ReactPlayerWrapper = styled.div<{ isPreviewOn: boolean }>`
  width: 100%;
  height: ${({ isPreviewOn }) => (isPreviewOn ? 0 : '100%')};
  visibility: ${({ isPreviewOn }) => (isPreviewOn ? 'hidden' : 'visible')};
`
